export default __webpack_public_path__ + "static/media/0x9af3b7dc29d3c4b1a5731408b6a9656fa7ac3b72.213acefa.webp";